import { useQuery } from '@tanstack/react-query';
import { getCycleSnapshot } from '@/api/lockedSummary';
import { transientReadRetryOptions } from '@/lib/transientApiErrors';

type Source = 'live' | 'snapshot';

export function useSignoffData(params: { cycleId?: string | number; source: Source; snapshotId?: string | number }) {
  const { cycleId, source, snapshotId } = params;

  return useQuery({
    queryKey: ['signoffData', { source, cycleId, snapshotId }],
    queryFn: async () => {
      if (source === 'snapshot') {
        if (!snapshotId) return { rows: [], meta: null };
        const resp = await getCycleSnapshot(snapshotId);
        return { rows: resp.data, meta: resp.meta };
      }
      // live
      if (!cycleId) return { rows: [], meta: null };
      const res = await fetch(`/api/locked-cycles/${cycleId}/assignments`, { credentials: 'omit' });
      if (!res.ok) throw new Error('Failed to load live signoff data');
      return res.json();
    },
    enabled: source === 'snapshot' ? !!snapshotId : !!cycleId,
    ...transientReadRetryOptions,
  });
}



